import { ProductSummaryModal } from './ProductSummaryModal';
import { connectProductSummaryModal } from './ProductSummaryModal.connect';

export const ConnectedProductSummaryModal = connectProductSummaryModal(ProductSummaryModal);
